import apiClient from "./axiosConfig";
import type { PermissionAction } from "config/rbacCatalog";

/** One resource's grants; `resource: "*"` with every action means full access. */
export type RolePermission = { resource: string } & Partial<Record<PermissionAction, boolean>>;

export interface RbacRole {
  _id: string;
  name: string;
  description?: string;
  permissions: RolePermission[];
  /** Legacy flag for full-access roles. */
  allPermissionsSelected?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface RoleInput {
  name: string;
  description: string;
  permissions: RolePermission[];
}

export const roleKeys = {
  all: ["rbac", "roles"] as const,
};

const BASE = "/api/rbac/roles";

export const fetchRoles = async (): Promise<RbacRole[]> => {
  const res = await apiClient.get<RbacRole[]>(BASE);
  return res.data;
};

export const createRole = async (input: RoleInput): Promise<RbacRole> => {
  const res = await apiClient.post<RbacRole>(BASE, input);
  return res.data;
};

export const updateRole = async (roleId: string, input: RoleInput): Promise<RbacRole> => {
  const res = await apiClient.put<RbacRole>(`${BASE}/${roleId}`, input);
  return res.data;
};

/** Answers 409 while the role is still assigned to active users. */
export const deleteRole = async (roleId: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${roleId}`);
};
